"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressDot = exports.progressDotToneMap = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/common/dot/dot");
require("@/components/common/text/text");
exports.progressDotToneMap = {
    todo: 'default',
    'in-progress': 'blue',
    done: 'green',
    blocked: 'red',
};
/**
 * 작업이 어느 단계에 있는지 점과 라벨로 보이는 표시.
 * 점의 색이 단계를 가르고 이름은 라벨이 맡으므로, 점은 보조 기술에 드러내지 않는다.
 */
let ProgressDot = class ProgressDot extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.variant = 'todo';
    }
    render() {
        return (0, lit_1.html) `
      <mm-dot tone=${exports.progressDotToneMap[this.variant]}></mm-dot>
      <mm-text size="12">
        <slot>${this.variant}</slot>
      </mm-text>
    `;
    }
};
ProgressDot.styles = (0, lit_1.css) `
    :host {
      display: inline-flex;
      align-items: center;
      gap: var(--space-1);
      white-space: nowrap;
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ type: String, reflect: true, useDefault: true })
], ProgressDot.prototype, "variant", void 0);
ProgressDot = __decorate([
    (0, decorators_js_1.customElement)('mm-progress-dot')
], ProgressDot);
exports.ProgressDot = ProgressDot;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHJvZ3Jlc3MtZG90LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsicHJvZ3Jlc3MtZG90LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLDZCQUEyQztBQUMzQyxxREFBMkQ7QUFJM0QsdUNBQW9DO0FBQ3BDLHlDQUFzQztBQUV6QixRQUFBLGtCQUFrQixHQUFHO0lBQ2hDLElBQUksRUFBRSxTQUFTO0lBQ2YsYUFBYSxFQUFFLE1BQU07SUFDckIsSUFBSSxFQUFFLE9BQU87SUFDYixPQUFPLEVBQUUsS0FBSztDQUM0QixDQUFBO0FBSTVDOzs7R0FHRztBQUVJLElBQU0sV0FBVyxHQUFqQixNQUFNLFdBQVksU0FBUSxnQkFBVTtJQUFwQzs7UUFTd0QsWUFBTyxHQUF1QixNQUFNLENBQUE7SUFVbkcsQ0FBQztJQVJDLE1BQU07UUFDSixPQUFPLElBQUEsVUFBSSxFQUFBO3FCQUNNLDBCQUFrQixDQUFDLElBQUksQ0FBQyxPQUFPLENBQUM7O2dCQUVyQyxJQUFJLENBQUMsT0FBTzs7S0FFdkIsQ0FBQTtJQUNILENBQUM7O0FBakJNLGtCQUFNLEdBQUcsSUFBQSxTQUFHLEVBQUE7Ozs7Ozs7R0FPbEIsQ0FBQTtBQUM0RDtJQUE1RCxJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLE9BQU8sRUFBRSxJQUFJLEVBQUUsVUFBVSxFQUFFLElBQUksRUFBRSxDQUFDOzRDQUFxQztBQVR0RixXQUFXO0lBRHZCLElBQUEsNkJBQWEsRUFBQyxpQkFBaUIsQ0FBQztHQUNwQixXQUFXLENBbUJ2QjtBQW5CWSxrQ0FBVyJ9